import { createQueryString } from '@eika-infrastruktur/utils';

import type { BankValidation, BicCode, CountryCode, Iban, NationalId, RegulatoryCode } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get } from './request';

const SERVICE_PATH = 'rest/resource/banks';

export function getRegulatoryCodes(): Promise<RegulatoryCode[]> {
    return get<RegulatoryCode[]>(`${CONTEXT_PATH}/${SERVICE_PATH}/regulatorycodes`);
}

export function validateBank(
    bic?: BicCode,
    nationalId?: NationalId,
    countryCode?: CountryCode,
): Promise<BankValidation> {
    const queryString = createQueryString({
        bic: bic?.value,
        nationalId: nationalId?.value,
        countryCode: countryCode?.value,
    });
    return get<BankValidation>(`${CONTEXT_PATH}/${SERVICE_PATH}/validate${queryString}`);
}

export function validateIban(iban: Iban): Promise<BankValidation> {
    const queryString = createQueryString({
        iban: iban.value,
    });
    return get<BankValidation>(`${CONTEXT_PATH}/${SERVICE_PATH}/iban/validate${queryString}`);
}
